/** @format */
import React from "react";
import { useNavigate } from "react-router-dom";
//img
import Calendar from "../../img/Bootcamp js calendario.svg";
import Clock from "../../img/Bootcamp js alarm.svg";
import Duration from "../../img/Bootcamp js duration.svg";
import Modality from "../../img/Bootcamp js modality.svg";
import Days from "../../img/Bootcamp js days.svg";
import Level from "../../img/Bootcamp js level.svg";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
//material ui
import { Box, Typography, Divider, Button, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
//icons
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Morning from "../../img/CourseMorning.svg";
import Night from "../../img/CourseNight.svg";
import { formatDate, formatTime, saveOnLS } from "../../helpers/courses";

const useStyles = (theme, isMobile) => ({
  apply: {
    width: { xl: "1373px", lg: "1098px", md: "878.4px" },
    height: { xl: "402px", lg: "402px", md: "402px" },
    borderRadius: "47px",
    background:
      "linear-gradient(to bottom, #071a3e, #071a3e, #071a3e, #071a3e, #071a3e)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflow: "hidden",
    marginTop: "76px",
    listItem: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      margin: "0px 0px 21px 28.8px",
    },
    listText: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
    },
    listIcon: {
      width: "21px",
      height: "21px",
      marginTop: "5px",
    },
    applyButton: {
      enabled: {
        width: "192px",
        height: "52px",
        borderRadius: "100px",
        background:
          "linear-gradient(100deg, rgba(255,6,46,1) 0%, rgba(208,14,46,1) 100%);",
        color: theme.palette.white.main,
        textTransform: "none",
        fontSize: 15.5,
        fontWeight: 550,
        margin: "0 0 39px",
      },
      disabled: {
        width: "192px",
        height: "52px",
        borderRadius: "100px",
        background:
          "linear-gradient(100deg, rgba(255,6,46,1) 0%, rgba(208,14,46,1) 100%);",
        color: "#A20000",
        textTransform: "none",
        fontSize: 15.5,
        fontWeight: 550,
        margin: "0 0 39px",
      },
    },
    icon: {
      enabled: {
        p: "5px",
        height: "14px",
        width: "14px",
        borderRadius: "58px",
        color: "#d00e2e",
        bgcolor: theme.palette.white.main,
        ml: "3px",
        boxShadow:
          "4px 8px 20px 0 rgba(0, 0, 0, 0.15), inset 7px 0 20px 0 rgba(255, 255, 255, 0.15)",
      },
      disabled: {
        p: "5px",
        height: "14px",
        width: "14px",
        borderRadius: "58px",
        color: "#d00e2e",
        bgcolor: "#F94B4B",
        ml: "3px",
        boxShadow:
          "4px 8px 20px 0 rgba(0, 0, 0, 0.15), inset 7px 0 20px 0 rgba(255, 255, 255, 0.15)",
      },
    },
  },
  schedule: {
    width: { xl: "488px", lg: "488px", md: "400px" },
    textTransform: "uppercase",
    height: "41px",
    background: theme.palette.white.main,
    display: "flex",
    alignItems: "center",
    borderRadius: "20.5px",
    marginRight: "41px",
  },
  typography: {
    descriptionSubtitle: {
      fontSize: isMobile ? 14 : 16,
      fontWeight: "bold",
      letterSpacing: "2px",
      color: theme.palette.red.main,
      marginBottom: "10px",
    },
    descriptionTitle: {
      fontSize: isMobile ? 32 : 65,
      fontWeight: "lighter",
      fontFamily: theme.typography.montserrat.regular,
      color: theme.palette.blue.main,
      lineHeight: "43px",
    },
    title: {
      color: theme.palette.yellow.main,
      fontFamily: theme.typography.montserrat.regular,
      fontSize: 30,
      fontWeight: 900,
    },
    text: {
      fontFamily: theme.typography.anaHeim.regular,
      fontSize: 24,
      margin: "15px 15px",
    },
    apply: {
      start: {
        color: theme.palette.white.main,
        fontFamily: theme.typography.montserrat.regular,
        fontSize: { xl: "28px", lg: "28px", md: "20px" },
        margin: "0 0 0 82px",
        online: {
          color: theme.palette.white.main,
          fontFamily: theme.typography.montserrat.regular,
          fontSize: { xl: "20px", lg: "20px", md: "12px" },
          margin: "0 0 0 82px",
        },
      },
      schedule: {
        color: theme.palette.red.main,
        fontFamily: theme.typography.montserrat.regular,
        fontSize: { xl: "24px", lg: "22px", md: "19px", sm: "20px" },
        marginLeft: "10px",
      },
      description: {
        color: theme.palette.white.main,
        fontFamily: theme.typography.montserrat.regular,
        fontSize: { xl: "18px", sm: "15px" },
        lineHeight: "24px",
        letterSpacing: "-0.32px",
      },
      value: {
        color: theme.palette.white.main,
        fontFamily: theme.typography.montserrat.bold,
        fontSize: "18px",
        lineHeight: "24px",
        letterSpacing: "-0.32px",
      },
      lastChance: {
        color: theme.palette.white.main,
        fontFamily: theme.typography.sourceSansPro.semibold,
        fontSize: "27px",
        letterSpacing: "7.5px",
        lineHeight: "26px",
        margin: "1rem",
      },
    },
    preparation: {
      color: theme.palette.white.main,
      margin: "1rem",
      fontFamily: theme.typography.montserrat.regular,
      fontSize: "1.2rem",
    },
  },
});

const BookingCard = (course) => {
  const {
    info,
    startDate,
    endDate,
    startHour,
    endHour,
    shift,
    weekDays,
    avialability,
    month,
    year,
    bootcampPreparation,
    tag,
  } = course;

  const isMobile = useMediaQuery("(max-width:899px)");

  const theme = useTheme();
  const classes = useStyles(theme, isMobile);

  const navigate = useNavigate();

  const isAvailable =
    info?.availability && info?.vacancyStatus && info?.status === "disponible";

  return (
    <Box sx={classes.apply}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          marginTop: "40px",
        }}
      >
        <Typography sx={classes.typography.apply.start}>
          <b>
            {month.toUpperCase()} {year} |
          </b>{" "}
          EN VIVO
        </Typography>
        <Box sx={classes.schedule}>
          <img
            src={shift === "mañana" ? Morning : Night}
            alt=""
            style={{ height: "24px", marginLeft: "10px" }}
          />

          {tag.includes("ATR") ? (
            <Typography sx={classes.typography.apply.schedule}>
              {shift}
              <b> | A TU RITMO</b>
            </Typography>
          ) : (
            <Typography sx={classes.typography.apply.schedule}>
              TURNO{" "}
              <b>
                {shift} | {formatTime(startHour)} a {formatTime(endHour)}hs
              </b>
            </Typography>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          marginTop: "5px",
          marginLeft: "5px",
        }}
      >
        {" "}
        <Typography sx={classes.typography.apply.start.online}>
          100% ONLINE
        </Typography>
      </Box>
      <Divider
        variant="middle"
        sx={{
          width: "95%",
          height: "0.2px",
          margin: "15.5px 0px 36px",
          backgroundColor: theme.palette.white.main,
        }}
      />
      <Box
        sx={{ display: "flex", justifyContent: "space-evenly", width: "100%" }}
      >
        <Box>
          <Box sx={classes.apply.listItem}>
            <img
              src={Calendar}
              alt="calendar"
              style={{
                width: "21px",
                height: "21px",
                margin: "2.5px 7.6px 0 0",
              }}
            />
            <Box sx={classes.apply.listText}>
              <Typography sx={classes.typography.apply.description}>
                Fechas:{" "}
                <b>
                  {formatDate(startDate)} a {formatDate(endDate)}
                </b>
              </Typography>
            </Box>
          </Box>
          <Box sx={classes.apply.listItem}>
            <img
              src={Clock}
              alt="calendar"
              style={{
                width: "21px",
                height: "21px",
                margin: "2.5px 7.6px 0 0",
              }}
            />
            <Box sx={classes.apply.listText}>
              <Typography sx={classes.typography.apply.description}>
                Horario:{" "}
                <b>
                  de {formatTime(startHour)} a {formatTime(endHour)}hs
                </b>
              </Typography>
            </Box>
          </Box>
          <Box sx={classes.apply.listItem}>
            <img
              src={Duration}
              alt="calendar"
              style={{
                width: "21px",
                height: "21px",
                margin: "2.5px 7.6px 0 0",
              }}
            />
            <Box sx={classes.apply.listText}>
              <Typography sx={classes.typography.apply.description}>
                Duración: <b>6 semanas (57 horas)</b>
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box>
          <Box sx={classes.apply.listItem}>
            <img
              src={Modality}
              alt="calendar"
              style={{
                width: "21px",
                height: "21px",
                margin: "2.5px 7.6px 0 0",
              }}
            />
            <Box sx={classes.apply.listText}>
              <Typography sx={classes.typography.apply.description}>
                Modalidad: <b>Part-time</b>
              </Typography>
            </Box>
          </Box>
          <Box sx={classes.apply.listItem}>
            <img
              src={Days}
              alt="calendar"
              style={{
                width: "21px",
                height: "21px",
                margin: "2.5px 7.6px 0 0",
              }}
            />
            <Box sx={classes.apply.listText}>
              <Typography sx={classes.typography.apply.description}>
                Días: <b>{weekDays}</b>
              </Typography>
            </Box>
          </Box>
          <Box sx={classes.apply.listItem}>
            <img
              src={Level}
              alt="calendar"
              style={{
                width: "21px",
                height: "21px",
                margin: "2.5px 7.6px 0 0",
              }}
            />
            <Box sx={classes.apply.listText}>
              <Typography sx={classes.typography.apply.description}>
                Nivel: <b>inicial</b>
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box>
          {isAvailable ? (
            <Typography sx={classes.typography.apply.lastChance}>
              {" "}
              {info?.vacancyStatus ? "ÚLTIMAS VACANTES" : "NO HAY VACANTES"}
            </Typography>
          ) : null}

          {info?.vacancyStatus && isAvailable ? (
            <Button
              disabled={avialability ? false : true}
              sx={
                avialability
                  ? classes.apply.applyButton.enabled
                  : classes.apply.applyButton.disabled
              }
              endIcon={
                <ArrowForwardIosIcon
                  sx={
                    avialability
                      ? classes.apply.icon.enabled
                      : classes.apply.icon.disabled
                  }
                />
              }
              onClick={() =>
                saveOnLS(info, () => navigate("/aplica/intro/formulario"))
              }
            >
              Aplicar
            </Button>
          ) : null}
        </Box>
      </Box>
      <Divider
        variant="middle"
        sx={{
          width: "95%",
          height: "0.2px",
          margin: "15.5px 0 0",
          backgroundColor: theme.palette.white.main,
        }}
      />
      <Box>
        <Typography sx={classes.typography.preparation}>
          <ErrorOutlineIcon sx={{ height: "1.2rem" }} /> {bootcampPreparation}
        </Typography>
      </Box>
    </Box>
  );
};

export default BookingCard;
